import React from 'react';
import i18n from 'app/common/lib/i18n';
import { Spinner } from 'gestalt';

const styles = {
  loadingIndicatorMask: {
    position: 'absolute',
    backgroundColor: '#fff',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    opacity: '0.7',
    borderRadius: '8px',
    zIndex: '100',
  },
  spinner: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    opacity: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '101',
  },
};

export const LoadingMask = (props) => (
  <div>
    <div style={styles.spinner}>
      <Spinner accessibilityLabel={i18n._('Loading')} show />
    </div>
    <div style={styles.loadingIndicatorMask} />
  </div>
);

export default LoadingMask;
